module.exports = __webpack_public_path__ + "img/logo.cb90d0a8.png";